var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD058",
    d: "M10.285 6.429H12V18h-1.715v-.857H9v-.429h-.43v-.428h-.428v-.429h-.429v-.428h-.429V15h-.428v-1.286h-.429v-3.428h.429V9h.428v-.429h.429v-.428h.429v-.429h.428v-.428H9v-.429h1.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C056",
    d: "M13.714 6.429H12V18h1.714v-.857H15v-.429h.428v-.428h.429v-.429h.428v-.428h.429V15h.429v-1.286h.428v-3.428h-.428V9h-.429v-.429h-.429v-.428h-.428v-.429h-.429v-.428H15v-.429h-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C04A07",
    d: "M11.143 11.571h-.858v-1.285h.429v-.429h1.714v.429h-.857v.428h-.428zm3-2.571h-.858v.857h.429v1.714h-.429v.857h.429v.858h.429v.857h.428V15h.857v-.857H15v-.857h-.429v-.857h-.428v-.858h.428V9.43h-.428zm-3 3.428h-.858V15h.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86609",
    d: "M13.285 9v.857h-2.571v.429h-.429v1.285h2.143v.857h-2.143V15h-.857V9.857h.429V9.43h.428V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86609",
    d: "M12.428 10.286V9h.857v.857h.429v1.714h-.429v.857h.429v.858h.429v.857h.428V15h-.857v-.429h-.429v-.857h-.428v-.857h-.429v-1.714h.429v-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 5.571h-1.715V6H9v.429h-.857v.428h-.429v.429h-.429v.428h-.428v.429h-.429V9H6v1.286h-.43v3H6v1.285h.428v.857h.429v.43h.428v.428h.429v.428h.429v.429H9v-.429h-.43v-.428h-.428v-.429h-.429v-.428h-.429V15h-.428v-1.286h-.429v-3.428h.429V9h.428v-.429h.429v-.428h.429v-.429h.428v-.428H9v-.429h1.285V6.43H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29914",
    d: "M12 5.571h1.714V6H15v.429h.857v.428h.428v.429h.429v.428h.429v.429h.428v.428H18v1.715h.428v3H18v1.285h-.429v.857h-.428v.43h-.429v.428h-.429v.857H15v-.429h.428v-.428h.429v-.429h.428v-.428h.429V15h.429v-1.286h.428v-3.428h-.428V9h-.429v-.429h-.429v-.428h-.428v-.429h-.429v-.428H15v-.429h-1.286V6.43H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.285 17.143H9v.428h.857V18h.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29914",
    d: "M13.714 17.143H15V18h-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6A6",
    d: "M12 18h-1.715v.428H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29914",
    d: "M14.143 18H12v.428h2.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.285 5.143h3.429v.428h-3.429zm3.429.428H15V6h-1.286zM15 6h.857v.429H15zm.428.429h.857v.428h-.857zm.429.428h.857v.429h-.857zm.857.429h.429v.428h-.429zm.429.428h.428v.429h-.428zm.428.429H18v.428h-.429zM18 8.57h.428v1.715H18zm0 4.715h.428v1.285H18zM17.143 15h.428v.857h-.428zm-.429.857h.429v.429h-.429zm.857-1.286H18V15h-.429zm-1.286 1.715h.429v.428h-.429zm0 .428h.429v.429h-.429zm-.428.429h.428v.428h-.428zm-.857 0h.857v.428H15zm0 .428h.428V18H15zm-4.715.857h3.858v.43h-3.858zM9 17.572h.857V18H9zm-.857-.428H9v.428h-.857zm-.429-.429h.429v.429h-.429zM9.857 18h.428v.428h-.428zm4.286 0H15v.428h-.857zm-6.858-1.714h.429v.428h-.429zm-.428-.429h.428v.429h-.428zm-.429-.428h.429v.428h-.429zM6 14.57h.428v.857H6zm-.429-1.285H6v1.285h-.43zm-.428-3h.428v3h-.428zM5.57 9H6v1.286h-.43zM6 8.143h.428V9H6zm.428-.429h.429v.429h-.429zm.429-.428h.428v.428h-.428zm.428-.429h.429v.429h-.429zm.429-.428h.429v.428h-.429zM8.143 6H9v.429h-.857zM9 5.571h1.285V6H9zm9.428 4.715h.429v3h-.429z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegen);
export default __webpack_public_path__ + "static/media/degen.29187378b5f6ee74428db8aeff343a79.svg";
export { ForwardRef as ReactComponent };